import { useSelector } from "react-redux";

import { ThemeProvider } from "@mui/material/styles";
import { StyledEngineProvider } from "@mui/material";

// defaultTheme
import themes from "../themes";
import { PersonaProvider } from "./persona";
import { SnackbarProvider } from 'notistack';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

export const GlobalContextProvider = ({ children }) => {
  const customization = useSelector((state) => state.customization);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes(customization)}>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{
            horizontal: "center",
            vertical: "bottom",
          }}
        >
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <PersonaProvider>
              {
                children
              }
            </PersonaProvider>
          </LocalizationProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};